export interface DataOptions {
    disableChildren: boolean;
    fromAgeAdult: number;
    disablePets: boolean;
    hidePriceTable: boolean;
    hideEquipment: boolean;
}

export const getDataOptions = (): DataOptions => {
    var dataOptions: DataOptions = { disableChildren: false, 
        fromAgeAdult: 16,
        disablePets: false,
        hidePriceTable: false,
        hideEquipment: false,
    } as DataOptions;
    var dataOptionsJSON = document.querySelector('[data-option]')?.getAttribute('data-option');
    if(dataOptionsJSON){
        try{
            dataOptions = JSON.parse(dataOptionsJSON);
            if(!dataOptions.disableChildren)
            {
                dataOptions.disableChildren = false;
            }
            if(!dataOptions.disablePets)
            {
                dataOptions.disablePets = false;
            }
            if(!dataOptions.fromAgeAdult)
            {
                dataOptions.fromAgeAdult = 16;
            }
            if(!dataOptions.hidePriceTable)
            {
                dataOptions.hidePriceTable = false;
            }
            if(!dataOptions.hideEquipment)
            {
                dataOptions.hideEquipment = false;
            }
        }
        catch(e: any)
        { 
            dataOptions = { 
                disableChildren: false, 
                fromAgeAdult: 16,
                disablePets: false, 
                hidePriceTable: false,
                hideEquipment: false,
            } as DataOptions;
            console.warn(e);
        }
    }
    return dataOptions;
  };